import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { SortingPagingData } from '@helpers/sorting-paging-data';
import { Page } from '@interfaces/page';
import { forkJoin, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ListIncomeByStickers } from '../_models/list-income-by-stickers.model';

const incomeByStickersURL = environment.apiBaseURL + '/income-by-stickers';

const pageableTotalElements      = incomeByStickersURL + '/pageable/count';
const pageableIncomeByStickers   = incomeByStickersURL + '/pageable';
@Injectable({
  providedIn: 'root'
})
export class IncomeByStickersService {
  
  constructor(private http: HttpClient) { }

  public pageable(sortingPaging: SortingPagingData, searchForm: any, fromDate: string, toDate: string) {
    return forkJoin([
      this.findAllByFilter(sortingPaging, searchForm, fromDate, toDate),
      this.countAllByFilter(sortingPaging, searchForm, fromDate, toDate)
    ]);
  }

  public findAllByFilter(sortingPaging: SortingPagingData, searchForm: FormGroup, fromDate: string, toDate: string): Observable<Page<ListIncomeByStickers>> {
    return this.http.get<Page<ListIncomeByStickers>>(pageableIncomeByStickers, { params: this.createSearchHttpRequestParams(sortingPaging, searchForm, fromDate, toDate) });
  }

  public countAllByFilter(sortingPaging: SortingPagingData, searchForm: FormGroup, fromDate: string, toDate: string): Observable<number> {
    return this.http.get<number>(pageableTotalElements, { params: this.createSearchHttpRequestParams(sortingPaging, searchForm, fromDate, toDate) });
  }

  private createSearchHttpRequestParams(sortingPaging: SortingPagingData, searchForm: FormGroup, fromDate: string, toDate: string) {
    let requestParams = new HttpParams();

    if (sortingPaging != null) {
      requestParams = requestParams.set("page", sortingPaging.getPageNumber());
      requestParams = requestParams.set("pageSize", sortingPaging.getPageSize());
    }
    Object.entries(searchForm).forEach(item => {
      if (item[1] && item[1].length !== 0) {
        requestParams = requestParams.set(item[0], item[1]);
      }
    });
    requestParams = this.filter(requestParams, searchForm, fromDate, toDate);

    return requestParams;
  }

  filter(requestParams: HttpParams, searchForm : any, fromDate: string, toDate: string){
    if (searchForm != null && searchForm.techPointMobileAppId != '' && searchForm.techPointMobileAppId != null) {
      requestParams = requestParams.set('mobileAppId', searchForm.techPointMobileAppId);
    }

    if(fromDate && fromDate.length !== 0) {
      requestParams = requestParams.set("validFrom", fromDate);
     }

    if(toDate && toDate.length !== 0) {
        requestParams = requestParams.set("validTo", toDate);
    }

    return requestParams;
  }
}
